
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "VEmployerServicesExtension",

  setup() {
    return {};
  },
});
